// components/A1cForm.js
import React, { useState } from "react";
import { auth, db } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

export default function A1cForm({ onSave }) {
  const [a1c, setA1c] = useState("");
  const [dateTime, setDateTime] = useState("");

  const handleSave = async () => {
    if (!a1c) return;
    const user = auth.currentUser;
    if (!user) return;

    try {
      await addDoc(collection(db, "users", user.uid, "a1cReadings"), {
        a1c: Number(a1c),
        createdAt: dateTime ? Timestamp.fromDate(new Date(dateTime)) : Timestamp.now(),
      });

      setA1c("");
      setDateTime("");
      onSave && onSave();
    } catch (err) {
      console.error("Error saving A1c:", err);
    }
  };

  return (
    <div className="form-container">
      <input
        type="number"
        step="0.1"
        placeholder="HbA1c (%)"
        value={a1c}
        onChange={(e) => setA1c(e.target.value)}
      />
      <input
        type="datetime-local"
        value={dateTime}
        onChange={(e) => setDateTime(e.target.value)}
      />
      <button onClick={handleSave} className="save-btn">Save Reading</button>
    </div>
  );
}
